import { useContext } from "react";
import {
  AccountContext,
  IAccountContextType,
} from "../../../contexts/AccountContext";

// Reader for the shared `/account` data.
//
// The actual SWR subscription, websocket revalidation, polling and account
// mutations live ONCE in <AccountContextProvider> (src/contexts/AccountContext).
// This hook only reads that single source of truth, so the 40+ call sites no
// longer each spin up their own `/account` fetch driver.
export const useGetAccount = (): IAccountContextType => {
  const ctx = useContext(AccountContext);
  if (!ctx) {
    throw new Error(
      "useGetAccount must be used within an <AccountContextProvider>"
    );
  }
  return ctx;
};
